import React, { useState } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { userManager } from '../utils/auth';
import { authConfig } from '../config/auth';
import Sidebar from '../components/Sidebar';
import InviteUserForm from '../components/InviteUserForm';
import SupportModal from '../components/SupportModal';
import OrientationLock from '../components/OrientationLock';
import '../styles/sidebar.css';

interface AppLayoutProps {
  children: React.ReactNode;
}

export default function AppLayout({ children }: AppLayoutProps) {
  const { user, logout, setUser } = useAuth();
  const [showInviteForm, setShowInviteForm] = useState(false);
  const [showSupportModal, setShowSupportModal] = useState(false);

  // Keep user data fresh (points, profile picture, etc.)
  React.useEffect(() => {
    const interval = setInterval(async () => {
      const updatedUser = await userManager.refreshUser(authConfig.apiUrl);
      if (updatedUser) setUser(updatedUser);
    }, 30000);

    return () => clearInterval(interval);
  }, [setUser]);

  return (
    <div className="app-container-with-sidebar">
      <OrientationLock />
      <Sidebar
        currentUser={user}
        onInviteUser={() => setShowInviteForm(true)}
        onLogout={logout}
        onSupport={() => setShowSupportModal(true)}
      />
      <main className="main-content-with-sidebar">
        {children}
      </main>
      {showInviteForm && (
        <InviteUserForm
          onSuccess={() => setShowInviteForm(false)}
          onCancel={() => setShowInviteForm(false)}
        />
      )}
      {showSupportModal && (
        <SupportModal
          currentUser={user}
          onClose={() => setShowSupportModal(false)}
        />
      )}
    </div>
  );
}
